// Shared constants for the Mortgage Submission Note Assistant (simplified).

export const STATUS_CONFIG = {
  draft: { label: 'Draft', color: 'bg-gray-100 text-gray-700' },
  in_progress: { label: 'In Progress', color: 'bg-blue-100 text-blue-800' },
  submitted: { label: 'Submitted', color: 'bg-indigo-100 text-indigo-800' },
  approved: { label: 'Approved', color: 'bg-emerald-100 text-emerald-800' },
  closed: { label: 'Closed', color: 'bg-slate-200 text-slate-700' },
};

export const STATUS_ORDER = Object.keys(STATUS_CONFIG);

export const TRANSACTION_TYPES = ['Purchase', 'Refinance', 'Switch/Transfer', 'HELOC'];

export const RATE_TYPES = ['Fixed', 'Adjustable (Variable)'];

export const INCOME_FREQUENCIES = ['Weekly', 'Bi-weekly', 'Semi-monthly', 'Monthly'];

export const PAYMENT_FREQUENCIES = [
  'Weekly', 'Accelerated Weekly', 'Bi-weekly', 'Accelerated Bi-weekly', 'Semi-monthly', 'Monthly',
];

export const INCOME_TYPES = [
  { value: 'base_hourly', label: 'Hourly (Base Income)' },
  { value: 'salary', label: 'Salary' },
  { value: 'two_year_average', label: 'Employment — 2-Year Average' },
  { value: 'self_employed', label: 'Self-Employed (T1 General)' },
  { value: 'other', label: 'Other' },
];

export const DOWN_PAYMENT_SOURCES = [
  'Savings', 'Gift', 'RRSP', 'TFSA', 'Sale of property', 'Borrowed', 'Existing equity', 'Other',
];

export const fmtMoney = (v) => {
  if (v === null || v === undefined || v === '') return '—';
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toLocaleString('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });
};
